var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"top-content"}),_c('div',{staticClass:"mid-content"},[_vm._v("正在学习使用中..................")]),_c('div',{staticClass:"bottom-content"},[_c('a',{attrs:{"href":"http://beian.miit.gov.cn/","target":"_blank"}},[_vm._v(" 辽ICP备2023014137号-1 ")])])])
}]

export { render, staticRenderFns }